import _objectSpread from "/Users/xudong/bs_workspace/RuoYi-Vue/hss_-warning_-h5/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import FormBox from '../../components/FormBox';
import { imageLoad, kfltApi } from '../../api/myApi.js';
import { Toast } from 'vant';
import CheckBook from '../../components/CheckBook';
export default {
  name: 'Home',
  components: {
    FormBox: FormBox,
    CheckBook: CheckBook
  },
  data: function data() {
    return {
      checked: false,
      data: {
        age: ''
      },
      isIpt: true,
      showPicker: false,
      zyqdImages: [],
      jsqdImages: [],
      ybwImages: [],
      rules: {
        age: [{
          required: true,
          message: '请输入年龄',
          trigger: 'blur'
        }],
        hospitalizationList: [{
          required: true,
          message: '请选择住院清单',
          trigger: 'change'
        }],
        settlementList: [{
          required: true,
          message: '请选择结算清单',
          trigger: 'change'
        }],
        medicalInsuranceOutside: [{
          type: 'number',
          message: '必须为数字值'
        }, {
          pattern: /^\d+(\.\d{0,2})?$/,
          message: '最多保留两位小数'
        }],
        reductionAmount: [{
          type: 'number',
          message: '必须为数字值'
        }, {
          pattern: /^\d+(\.\d{0,2})?$/,
          message: '最多保留两位小数'
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    inspectBtn: function inspectBtn(topData, isD) {
      this.isIpt = isD;
      this.data = _objectSpread(_objectSpread({}, this.data), topData);
    },
    zyqdAfterReadAvatar: function zyqdAfterReadAvatar(file) {
      var _this = this;
      var formData = new FormData();
      formData.append('file', file.file);
      imageLoad(formData).then(function (res) {
        _this.zyqdImages.push({
          imgUrl: res.url,
          imgId: file.file.lastModified
        });
      });
    },
    jsqdAfterReadAvatar: function jsqdAfterReadAvatar(file) {
      var _this2 = this;
      var formData = new FormData();
      formData.append('file', file.file);
      imageLoad(formData).then(function (res) {
        _this2.jsqdImages.push({
          imgUrl: res.url,
          imgId: file.file.lastModified
        });
      });
    },
    ybwAfterReadAvatar: function ybwAfterReadAvatar(file) {
      var _this3 = this;
      var formData = new FormData();
      formData.append('file', file.file);
      imageLoad(formData).then(function (res) {
        _this3.ybwImages.push({
          imgUrl: res.url,
          imgId: file.file.lastModified
        });
      });
    },
    zyqdBeforeDelete: function zyqdBeforeDelete(index) {
      this.zyqdImages = this.zyqdImages.filter(function (item) {
        return item.imgId !== index.file.lastModified;
      });
    },
    jsqdBeforeDelete: function jsqdBeforeDelete(index) {
      this.jsqdImages = this.jsqdImages.filter(function (item) {
        return item.imgId !== index.file.lastModified;
      });
    },
    ybwBeforeDelete: function ybwBeforeDelete(index) {
      this.ybwImages = this.ybwImages.filter(function (item) {
        return item.imgId !== index.file.lastModified;
      });
    },
    onBlur: function onBlur() {
      var amount = (parseFloat(this.data.reductionAmount || 0) || 0).toFixed(2);
      this.data.reductionAmount = amount === '0.00' ? '' : amount;
    },
    onSubmit: function onSubmit(formName) {
      var params = _objectSpread(_objectSpread({}, this.data), {}, {
        hospitalizationList: this.zyqdImages.map(function (item) {
          return item.imgUrl;
        }).join(','),
        settlementList: this.jsqdImages.map(function (item) {
          return item.imgUrl;
        }).join(','),
        // medicalInsuranceOutside: this.ybwImages.map(item => item.imgUrl).join(','),
        serviceType: '3'
      });
      console.log(params, '1');
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          kfltApi(params).then(function (res) {
            Toast.success(res.msg);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};